export const ALLOWED_MARKDOWN_ELEMENTS = [
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'strong',
  'em',
  'hr',
  'br',
  'a',
  'ol',
  'ul',
  'li'
] as const;

// used to identify cai-cta urls
export const CAI_CTA_PROTOCOL = 'cai-cta:';

// used to identify standalone cai-cta urls
// In the future we may use these prefixes to help us know how
// to handle the cai-cta certain types of urls
export const CAI_CTA_STANDALONE_PREFIX = 'standalone';
